import { render, staticRenderFns } from "./RegistroPromocionDialogComponent.vue?vue&type=template&id=4ee718b5"
import script from "./RegistroPromocionDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistroPromocionDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports